import { createErrorReportingAsyncThunk } from "../../helpers";
import { CmrPdfParams, getCmrPdf, getSignedFileUrl } from "../../../api";

export const openSignedFile = createErrorReportingAsyncThunk(
  "data/files/openSignedFile",
  async (signedUrlEndpoint: string) => {
    const { url } = await getSignedFileUrl(signedUrlEndpoint);
    window.open(url, "_blank", "noreferrer");
  }
);

export const openCmrPdf = createErrorReportingAsyncThunk(
  "data/files/openCmrPdf",
  async (params: CmrPdfParams) => {
    const pdf = await getCmrPdf(params);
    window.open(URL.createObjectURL(pdf));
  }
);
